module.exports = __webpack_public_path__ + "img/foto_0.e0202c65.jpg";